// extracted by mini-css-extract-plugin
export default {"description":"styles_description__6tjb8","status":"styles_status__p0Eer","value":"styles_value__ZYhHM","label":"styles_label__avnzA"};